/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { usageGetInferenceSpendCaps } from "../funcs/usageGetInferenceSpendCaps.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { InferenceSpendCap } from "../models/components/inferencespendcap.js";
import {
  GetInferenceSpendCapsRequest,
  GetInferenceSpendCapsSecurity,
} from "../models/operations/getinferencespendcaps.js";
import { unwrapAsync } from "../types/fp.js";
export type GetInferenceSpendCapsQueryData = Array<InferenceSpendCap>;

export function prefetchGetInferenceSpendCaps(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetInferenceSpendCapsRequest | undefined,
  security?: GetInferenceSpendCapsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetInferenceSpendCapsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetInferenceSpendCapsQuery(
  client$: GramCore,
  request?: GetInferenceSpendCapsRequest | undefined,
  security?: GetInferenceSpendCapsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetInferenceSpendCapsQueryData>;
} {
  return {
    queryKey: queryKeyGetInferenceSpendCaps({
      gramSession: request?.gramSession,
    }),
    queryFn: async function getInferenceSpendCapsQueryFn(
      ctx,
    ): Promise<GetInferenceSpendCapsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(usageGetInferenceSpendCaps(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetInferenceSpendCaps(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "usage", "getInferenceSpendCaps", parameters];
}
